import React from 'react'
import { connect as connectRedux } from 'react-redux'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { compose } from 'recompose'
import PropTypes from 'prop-types'
import { Map } from 'immutable'
import { connect as connectStaticText } from '../StaticText/connect'
import { EMAIL_SIGNUP_GENERIC } from '../../services/email-signup/index'
import EmailCapture from '../EmailCapture/index'
import Button, { TYPES } from '../Button/index'
import { TYPE_LOGIN } from '../../services/dialog/index'
import { H3, H5 } from '../Heading/index'
import { getBoundActions } from '../../actions/index'

function PlaylistAnonymousPage (props) {
  const {
    staticText,
    doEmailSignup,
    setOverlayDialogVisible,
    emailSignup,
  } = props

  return (
    <div className="playlist-anonymous">
      <div className="playlist-anonymous__container">
        <div className="playlist-anonymous__title">
          <H3>{staticText.getIn(['data', 'pleaseLogIn'])}</H3>
        </div>
        <Button
          onClick={() => setOverlayDialogVisible(TYPE_LOGIN)}
          className="playlist-anonymous__sign-up-btn"
          type={TYPES.PRIMARY}
        >
          {staticText.getIn(['data', 'logIn'])}
        </Button>
        <div className="playlist-anonymous__email-capture-wrapper">
          <H5 className="playlist-anonymous__email-capture-title">
            {staticText.getIn(['data', 'enterYourEmail'])}
          </H5>
          <EmailCapture
            formName={EMAIL_SIGNUP_GENERIC}
            success={emailSignup.get('success')}
            siteSegment={Map()}
            className={['playlist-anonymous__email-capture']}
            onFormSubmit={doEmailSignup}
            inverted={false}
            buttonText={staticText.getIn(['data', 'signUp'])}
            inputPlaceholder={staticText.getIn(['data', 'emailPlaceholder'])}
            uiLocation="Playlist Deeplink"
          />
        </div>
      </div>
    </div>
  )
}

PlaylistAnonymousPage.propTypes = {
  staticText: ImmutablePropTypes.map.isRequired,
  doEmailSignup: PropTypes.func.isRequired,
  setOverlayDialogVisible: PropTypes.func.isRequired,
  emailSignup: ImmutablePropTypes.map.isRequired,
}

export default compose(
  connectStaticText({ storeKey: 'playlistAnonymousPage' }),
  connectRedux(
    (state) => ({
      emailSignup: state.emailSignup,
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        doEmailSignup: actions.emailSignup.doEmailSignup,
        setOverlayDialogVisible: actions.dialog.setOverlayDialogVisible,
      }
    },
  ),
)(PlaylistAnonymousPage)
